export enum QueryKey {
  ArAgingReport = 'arAgingReport',
  FamilyStatementsReport = 'familyStatementsReport',
  Assessments = 'assessments',
  AuditLogs = 'auditLogs',
  CalendarEvents = 'calendarEvents',
  Calendars = 'calendars',
  CalendarShareTokens = 'calendarShareTokens',
  CenterCustomizations = 'centerCustomizations',
  AppConfigurations = 'appConfigurations',
  Curriculums = 'curriculums',
  CurriculumsOrg = 'curriculumsOrg',
  DailyStaffHoursSummaryReport = 'dailyStaffHoursSummaryReport',
  DailyStudentHoursSummaryReport = 'dailyStudentHoursSummaryReport',
  StudentHoursOverviewReport = 'studentHoursOverviewReport',
  DiscoveryTopics = 'discoveryTopics',
  DiscoveryTopicsOrg = 'discoveryTopicsOrg',
  DropOffSpaces = 'dropOffSpaces',
  EmailUniqueness = 'emailuniqueness',
  EnrollmentCustomFields = 'enrollmentCustomFields',
  ExpiryAlerts = 'expiryAlerts',
  EnrollmentCounts = 'enrollmentCounts',
  Enrollments = 'enrollments',
  FeatureToggles = 'featureToggles',
  FeatureToggleOverrides = 'featureToggleOverrides',
  ExternalSponsors = 'externalSponsors',
  Families = 'families',
  FamilyAttendees = 'familyAttendees',
  FeatureFlag = 'featureFlag',
  File = 'file',
  Groups = 'groups',
  GrowthIndicators = 'growthIndicators',
  Holidays = 'holidays',
  LearningReports = 'learningReports',
  LearningSettings = 'learningSettings',
  LessonPlans = 'lessonPlans',
  Lessons = 'lessons',
  MealsDashboard = 'mealsDashboard',
  MemberInfoChanges = 'memberInfoChanges',
  MemberPIN = 'memberPin',
  MemberPINReport = 'memberPinReport',
  Members = 'members',
  MessagingAdminDirectory = 'messagingAdminDirectory',
  MessagingAdminMessagingDirectory = 'messagingAdminMessagingDirectory',
  MessagingFamilyDirectory = 'messagingFamilyDirectory',
  MessagingGroups = 'messagingGroups',
  MessagingInternalDirectory = 'messagingInternalDirectory',
  Notifications = 'notifications',
  Onboarding = 'onboarding',
  PayrollReport = 'payrollReport',
  PhotoLibrary = 'photoLibrary',
  Programs = 'programs',
  PublicCenterInfo = 'publicCenterInfo',
  PublicInterestFormCounts = 'publicInterestFormCounts',
  PublicInterestForms = 'publicInterestForms',
  PublicOrgInfo = 'publicOrgInfo',
  PublicRegistrationLogs = 'publicRegistrationLogs',
  RegistrationEmailTemplates = 'registrationEmailTemplates',
  RotessaEntities = 'rotessaEntities',
  RotessaNaturalPersons = 'rotessaNaturalPersons',
  RotessaStakeholders = 'rotessaStakeholders',
  Routines = 'routines',
  Spaces = 'spaces',
  Staff = 'staff',
  StaffSignInDetailReport = 'staffSignInDetailReport',
  StudentInfoChanges = 'studentInfoChanges',
  StudentSignInDetailReport = 'studentSignInDetailReport',
  SubsidyClaimReport = 'subsidyClaimReport',
  SupportedVersions = 'supportedVersions',
  SystemLogs = 'systemLogs',
  Tasks = 'tasks',
  Upload = 'upload',
  AttendanceEditRequests = 'attendanceEditRequests',
  MyAttendanceEditRequests = 'myAttendanceEditRequests',
  ScheduleTemplates = 'scheduleTemplates',
  ArchivedScheduleTemplates = 'archivedScheduleTemplates',
  DailySchedules = 'dailySchedules',
  ScheduleStaff = 'scheduleStaff',
}
